import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Consent } from '../../model/consent.model';
import { selectEnableConsentShown } from '../../consent.selector';
import { ConsentState } from '../../consent.state';
import { ContainerComponent } from '../../../shared/components/container-component/unsubscribe.component';
import { BsModalService } from 'ngx-bootstrap';
import { EnableConsentAuthDialogComponent } from '../enable-consent-auth-dialog/enable-consent-auth-dialog.component';
import * as updateActions from '../../actions/update-consent.actions';
import * as enableActions from '../../actions/enable-consent.actions';
import { SourceAppService } from '../../../../core/services/source-app.service';

import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/filter';
import { selectEnabledApplicationList } from '../../../applications/application.selector';
import { Observable } from 'rxjs';
import { ApplicationList } from '../../../applications/model/application/application-list.model';
import { map } from 'rxjs/operators';

@Component({
    selector: 'ssf-consent',
    template: require('./consent.component.html'),
    styles: [require('./consent.component.scss')]
})
export class ConsentComponent extends ContainerComponent {
    public i18n = 'CONSENT.';
    // modal window configuration
    private fullscreenModalConf = Object.assign({}, {class: 'ssf-modal_fullscreen-wrapper', ignoreBackdropClick: false});
    public consent: Consent;
    public enabledApplicationList$: Observable<ApplicationList>;

    get btnEnabled(): Observable<boolean> {
        return this.enabledApplicationList$.pipe(
            map(value => value && value.applications && value.applications.length > 0)
        );
    }

    constructor(private store: Store<ConsentState>, private modalService: BsModalService,
                public sourceService: SourceAppService) {
        super();

        // -------------------------------------------------------------------------------------------------------------

        this.enabledApplicationList$ = this.store.select(selectEnabledApplicationList);

        this.store.select(selectEnableConsentShown)
            .takeUntil(this.ngUnsubscribe)
            .distinctUntilChanged()
            .filter((shown) => !!shown)
            .subscribe(() => this.modalService.show(EnableConsentAuthDialogComponent, this.fullscreenModalConf));

        this.modalService.onHide
            .takeUntil(this.ngUnsubscribe)
            .filter((reason: string) => !!reason) // only for esc button - reason === `esc`; close button fires ClosePopupAction too
            .subscribe(() => this.store.dispatch(new enableActions.EnableConsentCancelAction()));

        // -------------------------------------------------------------------------------------------------------------

    }

    public onSaveChanges() {
        this.store.dispatch(new updateActions.DisableConsentAction());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/components/consent/consent.component.ts